/**
 * @generated SignedSource<<78d1355af92767b4745d34e3ba88f9d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableDateRow_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_package">;
  readonly " $fragmentType": "RoomRatesTableDateRow_package";
};
export type RoomRatesTableDateRow_package$key = {
  readonly " $data"?: RoomRatesTableDateRow_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableDateRow_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateCell_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "19a586af1c2e2f348bc49521c9f83ee6";

export default node;
